import React from "react";
import styles from "./styles";

import {
  CustomIcon,
  TableNullData,
  UserInformation,
} from "../../../../components";
import Context from "../../../../context";
import Cookies from "js-cookie";
import values from "../../../../values";
import utils from "../../../../utils";
import constants from "../../../../values/constants";
import DropDownLoading from "../../../../components/DropDownLoading";
import { ABSENT_STATUS } from "../../../../values/dropdownItems";
import "./index.scss";
import convertGregorianToJalali from "../../../../utils/convertGregorianToJalali";
import { isNamedExportBindings } from "typescript";
import { useTranslation } from "react-i18next";

type Props = {
  data: any[];
};

const Body = ({ data }: Props) => {
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  // ========================================== JSX Content =============================================
  const { setShowModal, setSelectedAbsent } = React.useContext(
    Context.LogScreen
  );

  // function onClickCompany(company: any) {
  //   setSelectedCompany(company);
  //   setShowModal("SHOW_COMPANY_INFORMATION");
  // }
  // function onClickManager(company: any) {
  //   setSelectedCompany(company);
  //   setShowModal("SHOW_MANAGER_INFORMATION");
  // }
  // function onClickSuperAgent(company: any) {
  //   setSelectedCompany(company);
  //   setShowModal("SHOW_SUPERAGENT_INFORMATION");
  // }

  // function onUpdate(company: any) {
  //   setSelectedCompany(company);
  //   setShowModal("UPDATE");
  // }

  // function onDelete(company: any) {
  //   setSelectedCompany(company);
  //   setShowModal("DELETE");
  // }

  const { t } = useTranslation();

  function onApprove(service: any) {
    setSelectedAbsent(service);
    setShowModal("APPROVE");
  }

  if (data?.length <= 0 || !data) return <TableNullData />;
  return (
    <tbody id="company-table-body-container">
      {data?.map((absent: any, index: number) => {
        return (
          <tr
            key={`company-${index.toString()}`}
            className={`${absent?.service?.isChecked ? "unchecked" : ""}`}
          >
            <td
              className="pointer"
              // onClick={() => onClickCompany(absent)}
            >
              <UserInformation
                name={
                  absent?.student?.firstName + " " + absent?.student?.lastName
                }
                phoneNumber={
                  absent?.absentType === "STUDENT" ? t("student") : t("driver")
                }
              />
            </td>
            <td
              className="pointer"
              // onClick={() => onClickCompany(absent)}
            >
              <UserInformation
                name={
                  absent?.driver?.firstName + " " + absent?.driver?.lastName
                }
                phoneNumber={
                  absent?.absentType === "STUDENT" ? t("student") : t("driver")
                }
              />
            </td>
            <td
              className="pointer"
              // onClick={() => onClickManager(absent)}
            >
              {absent?.log?.map((item: any, index: number) => (
                <p key={"absent-status-from-" + index.toString()}>
                  {t(
                    ABSENT_STATUS?.map?.((item) => ({
                      ...item,
                      name: item.name,
                    }))?.find(
                      (item) =>
                        item?.value === absent?.log?.at(index)?.fromStatus
                    )?.name as string
                  )}
                </p>
              ))}
            </td>
            <td
              className="pointer"
              // onClick={() => onClickManager(absent)}
            >
              {absent?.log?.map((item: any, index: number) => (
                <p key={"absent-status-to-" + index.toString()}>
                  {t(
                    ABSENT_STATUS?.find(
                      (item) => item?.value === absent?.log?.at(index)?.toStatus
                    )?.name as string
                  )}
                </p>
              ))}
            </td>
            {/* <td>
              <CustomBadges title={company?.superAgentInformation?.city} type="primary" />
            </td> */}
            {/* actions */}
            <td
              className="pointer"
              // onClick={() => onClickManager(absent)}
            >
              {absent?.log?.map((item: any, index: number) => (
                <p key={"absent-status-to-" + index.toString()}>
                  {utils.convertGregorianToJalali({
                    date: absent?.log?.at(index)?.time,
                    format: "  hh:mm --- jYYYY/jMM/jDD",
                  })}
                </p>
              ))}
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default Body;
